export default "__VITE_ASSET__aLkmPC8j__"